import React from "react";

const FAQ = () => {
  return (
    <section className="px-4 py-12">
      <div className="max-w-4xl mx-auto">
        {/* Why Section */}
        <h2 className="mb-6 text-3xl font-bold md:text-4xl">
          Why You Should Use Revoke.cash.
        </h2>

        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold">
              1. Use Revoke.cash periodically.
            </h3>
            <p className="mt-2 text-gray-600">
              It is always good to limit your approvals whenever you are not
              actively using a dapp, especially for NFT marketplaces. This
              reduces the risk of losing your funds to hacks or exploits and can
              also help mitigate the damage of phishing scams.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold">
              2. Use Revoke.cash after getting scammed.
            </h3>
            <p className="mt-2 text-gray-600">
              Very often, scammers try to trick you into granting them an
              approval to your funds. Sort your approvals by most recent to find
              out which approvals are to blame and revoke them to prevent
              further damage. Unfortunately it is not possible to recover funds
              that have already been stolen.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold">
              3. Use the Revoke.cash browser extension.
            </h3>
            <p className="mt-2 text-gray-600">
              Prevention is better than mitigation. The Revoke.cash browser
              extension warns you when you're about to sign something
              potentially harmful. This can save you from phishing scams by
              making you think twice about what you're doing.
            </p>
          </div>
        </div>

        {/* FAQ Heading */}
        <h2 className="mt-16 mb-6 text-3xl font-bold md:text-4xl">
          Frequently Asked Questions
        </h2>

        <div className="space-y-6">
          <div>
            <h3 className="text-xl font-semibold">
              Can I use Revoke.cash to recover stolen assets?
            </h3>
            <p className="mt-2 text-gray-600">
              No. Revoke.cash is a preventative tool that helps you practice
              proper wallet hygiene. By regularly revoking active approvals you
              reduce the chances of becoming the victim of approval exploits.
              But unfortunately it cannot be used to recover any stolen funds.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold">
              Can hardware wallets save me from approval exploits?
            </h3>
            <p className="mt-2 text-gray-600">
              No. Hardware wallets are safer because keys are stored on the
              device, but with approvals attackers do not need your keys to take
              your tokens. Because of that hardware wallets offer no extra
              protection against approval exploits.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold">
              I want to revoke approvals, but when I add ETH to my account it
              gets stolen.
            </h3>
            <p className="mt-2 text-gray-600">
              If you have a sweeper bot on your account that steals any ETH as
              soon as it comes in, your seed phrase was compromised. Revoking
              approvals will not help in this situation. You should abandon this
              wallet and create a new one.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-semibold">
              Is it enough to disconnect my wallet instead of revoking
              approvals?
            </h3>
            <p className="mt-2 text-gray-600">
              No. Disconnecting your wallet from a website does not protect you
              from approval exploits. The website simply cannot see your address
              anymore, but the approvals stay active.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
